import * as React from 'react'
import { useInView } from 'react-intersection-observer';
import { ManagerContext } from '../../contexts/ManagerContext';
import { OpenAiContext } from '../../contexts/OpenAiContext';
import { UiContext } from '../../contexts/UiContext';
import {Box, Grid2 as Grid, Card, Button, Stack, Typography, ListItemIcon, ListItemButton, ListItemAvatar, Avatar, TextField } from '@mui/material'
import { styled } from '@mui/material/styles';
import DialogTitle from '@mui/material/DialogTitle';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ImageIcon from '@mui/icons-material/Image';
import WorkIcon from '@mui/icons-material/Work';
import BeachAccessIcon from '@mui/icons-material/BeachAccess';
import Container from '@mui/material/Container';
import ChatContainer from '../../components/chat/ChatContainer';
import Grow from '@mui/material/Grow';
import { Instagram } from '@mui/icons-material';
import PersonIcon from '@mui/icons-material/Person';

const TitleBar = styled(DialogTitle)(({ theme }) => ({
  background: 'linear-gradient(45deg, #808080, #0e1328)',
  color: '#fff',
  fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif',
  textAlign: 'center'
}));

const GrowOnView = ({ children }) => {
    const [ visible, setVisible ] = React.useState(false)
    const { ref, inView } = useInView({
      threshold: 0.1, // zmieniaj według potrzeb
    });
    React.useEffect(() => {
        if (inView) {
            setVisible(true)
        }
    }, [inView]);
          
  
    return (
      <Box
        ref={ref}
        sx={{
          transition: 'transform 0.3s ease, opacity 0.3s ease',
          transform: visible ? 'scale(1)' : 'scale(0.5)',
          opacity: visible ? 1 : 0,
        }}
      >
        {children}
      </Box>
    );
  };



export default function PayPage() {
    const pageName = 3 //donation_page
    const [ _isInit, _setIsInit ] = React.useState(false);
    const { openBackDrop, closeBackDrop } = React.useContext(UiContext);
    const { sendTask, setCurrentPage, connectionState, isInit} = React.useContext(ManagerContext);
    const { openai, 
        stream, setStream,
        activeRun, setActiveRun } = React.useContext(OpenAiContext);

    const [messages, setMessages] = React.useState([]);
    const [_chat, _setChat] = React.useState({
        assistant_id: 'asst_0td4cNuDeFE9hz2IRW6vZgvQ',
        activeThread: null,
      });
    
    const [ users, setUsers ] = React.useState([])
    const [ selected, setSelected ] = React.useState(0);
    const [ currentUserData, setCurrentUserData ] = React.useState({});
    const [ dataUpdated, setDataUpdated ] = React.useState({});

    const handelClickMain = (index) => {
        setSelected(index)
        setCurrentUserData(users[selected])
        setDataUpdated({})
        
    }


    React.useEffect(() =>{
    
            const handleInit = async () => {
                if(messages.length > 0) return;
                openBackDrop();
                setMessages([])
                const thread = await openai.beta.threads.create();
                _setChat(prev =>{
                    const newPrev = {
                        ...prev,
                        activeThread: thread,
                    }
                    console.log('PayPage init newChat', newPrev)
                    return newPrev
                });
                
                const result = await sendTask("get_instruction")
                const _stream = await openai.beta.threads.runs.create(
                    thread.id,
                    { 
                        assistant_id: 'asst_0td4cNuDeFE9hz2IRW6vZgvQ',
                        instructions: JSON.stringify(result.data.instructions),
                        additional_instructions: 'Przechodzimy na stronę donate. Zachęć odbiorcę do wsparcia poprzez wpłaty na rzecz rozwoju portalu komunikacyjnego i informacyjnego Mosaic Guardians. Nasi informatycy robia co w ich mocy aby idea znalazła największe grono odbiorców a przygoda nabrała niesamowitego kształtu oraz rozmachu. Staramy się aby inicjatywa była całkowicie darmowa jednak na tym etapie wasze wsparcie jest niezbędne',
                        // additional_messages: query?[ { role: "user", content: query } ]:null,
                        stream: true,
                        model: "gpt-4o-mini",

                    }
                );

                setStream(_stream)

                ready()
            };
            const fetchGetUsers = async () => {
                
                const users = await sendTask('get_users')
                console.log('fetchGetUsers', users.data)
                const json = JSON.parse(users.data)
                setUsers(()=>{
                    console.log('setUsers', json.users)
                    return json.users
                })
                console.log('fetchGetUsersss', json.users)
            }

            if ( connectionState === "OPEN" && isInit ){
                try{
                    // handleInit();
                    fetchGetUsers()
                }catch(error){
                    console.error(error)
                }  
            }
        }, [connectionState, isInit])

    const ready = () => {
        closeBackDrop();
        _setIsInit(true);
    }

    setCurrentPage(pageName)
    return (
        <Box sx={{ flexGrow: 1, width: {xs:'100%', md:'100%'}, height: 'calc(100dvh - 70px)', mt: 1, justifySelf: 'center', overflowY: 'auto', overflowX: 'hidden' }}>
            <Stack direction='row' sx={{ height: '100%'}}>
                <Box sx={{ width: '300px', background: 'black' }}>
                    <List>
                        {users.map((item, index) => (
                            <ListItem key={index} disablePadding sx={{ display: 'block', mb: index === 0 ? 2 : 0 }}>
                            <ListItemButton selected={index === selected && index !== 0}
                                onClick={() => handelClickMain(index)}>
                                <ListItemAvatar>
                                    <Avatar alt={item.nick_name} src="/static/images/avatar/2.jpg" />
                                </ListItemAvatar>
                                <Typography variant="inherit" noWrap>
                                {item.nick_name}
                                </Typography>
                            </ListItemButton>
                            </ListItem>
                        ))}
                    </List>
                </Box>
                <Box sx={{ width: '100%', background: 'black', overflowY: 'auto', overflowX: 'hidden' }}>
                    
                            {users[selected] && <List>
                                
                                {Object.entries(currentUserData).map(([key, item]) => {
                                    return(
                                        <ListItem key={key} disablePadding sx={{ display: 'block' }}>
                                            <Stack direction='row' spacing={2}>
                                            <Typography variant="inherit" noWrap sx={{ alignContent: 'center' }}>
                                                {key}:
                                            </Typography>
                                            <TextField 
                                                value={item}
                                                onChange={e => {
                                                    setCurrentUserData(prev =>{
                                                        const newPrev = {
                                                            ...prev,
                                                            [key]: e.target.value
                                                        }
                                                        return newPrev
                                                    })
                                                    setDataUpdated(prev =>{
                                                        const newPrev = {
                                                            ...prev,
                                                            [key]: e.target.value
                                                        }
                                                        return newPrev
                                                    })
                                                }}
                                            >
                                            </TextField>
                                            </Stack>
                                        
                                        </ListItem>
                                    )
                                }
                                
                                )}
                               
                                
                            
                            </List>}
                            <Button onClick={async () => {sendTask('update_user', {uid:users[selected].uid, ...dataUpdated})}}>
                                Save
                            </Button>
                                



                </Box>
            </Stack>
        </Box>
    );
}